import PropTypes from "prop-types";
import React from "react";

const Description = ({ description }) => {
  return (
    <div className="row mt-5">
      {description &&
        description.length > 0 &&
        description.map((desc, index) => (
          <div className="col-md-3 mb-2" key={index}>
            <div className="">{desc.description}</div>
          </div>
        ))}
    </div>
  );
};

export default Description;

Description.propTypes = {
  description: PropTypes.array.isRequired,
};
